import {Link} from '@freckle/educator-materials/ts/components/link'
import {H1} from '@freckle/educator-materials/ts/components/typography'
import {useSafeTranslation} from '@freckle/educator-materials/ts/helpers/translate'
import {SafeTrans} from '@freckle/educator-materials/ts/helpers/translate/component'
import {CenteredPage} from '@freckle/school/ts/common/components/common/centered-page'

export default function Expired() {
  const {t} = useSafeTranslation()
  const quotesLink = <Link href="mailto:quotes@freckle.com" reactRouter={false} />
  return (
    <CenteredPage>
      <H1>{t('EXPIRED_PAGE_TITLE')}</H1>
      <p>
        <SafeTrans i18nKey="EXPIRED_PAGE_INFO_WITH_LINK_TEXT" components={{quotesLink}} />
      </p>
    </CenteredPage>
  )
}
